import PermissionModel from '../models/PermissionModel';
import BaseStore from './BaseStore';

class PermissionStore extends BaseStore {
  constructor(transportLayer) {
    super(PermissionModel, transportLayer);
  }
}

export default PermissionStore;



// WEBPACK FOOTER //
// ./src/stores/PermissionStore.js